// import { notification } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import AppLayout from '../layouts';
import { routes } from '../routes';
import NotFoundPage from '../routes/error/NotFoundPage';
import rolesApi from '../api/roles';
import { useSelector } from 'react-redux';
import userPermissionsApi from '../api/user-permissions';

// const openErrorNotification = (error) => {
//   notification['error']({
//     message: 'Có lỗi xảy ra trong hệ thống',
//     description: `Lỗi xảy ra khi người dùng gọi hàm ${error.function}`,
//     placement: 'bottomRight',
//   });
// };

const AppRoutes = ({ match }) => {
  const isMount = useRef(false);
  const [route, setRoute] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    isMount.current = true;
    async function fetchRouteData() {
      try {
        if (isMount) {
          setLoading(true);
          setRoute(routes);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching menu data:', error);
        setLoading(false);
      }
    }
    fetchRouteData();

    return () => {
      isMount.current = false;
    };
  }, [authUser]);

  if (!authUser) {
    return <Redirect to="/login" />;
  }

  return (
    <React.Fragment>
      <Helmet>{/* <title>{title}</title> */}</Helmet>
      <AppLayout>
        {!loading && (
          <Switch>
            {route.map((route, index) => (
              <ProtectedRoute
                key={index}
                exact
                authUser={authUser}
                permission={route.permission}
                path={`${match.url}/${route.path}`}
                component={route.component}
              />
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        )}
      </AppLayout>
    </React.Fragment>
  );
};

const ProtectedRoute = ({
  authUser,
  permission,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    exact
    render={(props) => {
      if (authUser) {
        return <Component {...props} />;
      } else {
        return <Redirect to="/login" />;
      }
    }}
  />
);

export default withRouter(AppRoutes);
